import { render, staticRenderFns } from "./BasicParameters.vue?vue&type=template&id=f19a4164&scoped=true"
import script from "./BasicParameters.vue?vue&type=script&lang=js"
export * from "./BasicParameters.vue?vue&type=script&lang=js"
import style0 from "./BasicParameters.vue?vue&type=style&index=0&id=f19a4164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19a4164",
  null
  
)

export default component.exports